(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() { super(); }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-sticky');

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) requestAnimationFrame(this.reveal.bind(this));
        else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

/* ===== ENDURA: Dropdown menu on hover (DESKTOP only) - robust click ===== */
(function () {
  const isHoverDevice = window.matchMedia('(hover: hover) and (pointer: fine)');
  const isDesktop = window.matchMedia('(min-width: 990px)');

  function closeAll(exceptDetails) {
    document.querySelectorAll('header-menu details[open]').forEach((d) => {
      if (exceptDetails && d === exceptDetails) return;
      d.removeAttribute('open');
    });
  }

  function initHoverMenus() {
    if (!isHoverDevice.matches || !isDesktop.matches) return;

    document.querySelectorAll('header-menu').forEach((menu) => {
      const details = menu.querySelector('details');
      if (!details) return;

      // Dawn normalmente usa .header__submenu para el panel
      const submenu = details.querySelector('.header__submenu') || details;

      let closeTimer;

      const openNow = () => {
        window.clearTimeout(closeTimer);
        closeAll(details);
        details.setAttribute('open', 'open');
      };

      const closeSoon = () => {
        window.clearTimeout(closeTimer);
        closeTimer = window.setTimeout(() => {
          details.removeAttribute('open');
        }, 900); // 👈 MUCHO más tolerante para poder dar click
      };

      // Abre al entrar al item (link/summary)
      menu.addEventListener('mouseenter', openNow);

      // Mantén abierto mientras estés sobre el panel
      submenu.addEventListener('mouseenter', () => window.clearTimeout(closeTimer));

      // Cierra cuando salgas del item o del panel (con delay)
      menu.addEventListener('mouseleave', closeSoon);
      submenu.addEventListener('mouseleave', closeSoon);

      // Si haces foco con teclado, también abre
      menu.addEventListener('focusin', openNow);
      menu.addEventListener('focusout', closeSoon);
    });

    // Si sales de todo el header, cierra todo (con delay)
    const header = document.querySelector('.header');
    if (header) {
      let headerTimer;
      header.addEventListener('mouseleave', () => {
        window.clearTimeout(headerTimer);
        headerTimer = window.setTimeout(() => closeAll(), 900);
      });
      header.addEventListener('mouseenter', () => window.clearTimeout(headerTimer));
    }

    // Click fuera: cierra
    document.addEventListener('pointerdown', (e) => {
      const inHeaderMenu = e.target.closest('header-menu');
      if (!inHeaderMenu) closeAll();
    });
  }

  document.addEventListener('DOMContentLoaded', initHoverMenus);
})();

/* ===== ENDURA: Quiz dropdown on tap (MOBILE) — no navigate ===== */
(function () {
  const mqMobile = window.matchMedia('(max-width: 989px)');

  function init() {
    const wrap = document.querySelector('.endura-quiz-wrap');
    const btn = document.querySelector('[data-endura-quiz-btn]');
    if (!wrap || !btn) return;

    // evita doble init
    if (wrap.dataset.enduraQuizInit === '1') return;
    wrap.dataset.enduraQuizInit = '1';

    const open = () => wrap.classList.add('is-open');
    const close = () => wrap.classList.remove('is-open');
    const toggle = () => wrap.classList.toggle('is-open');

    // En mobile, el botón SOLO abre/cierra (no navega)
    btn.addEventListener('click', (e) => {
      if (!mqMobile.matches) return;
      e.preventDefault();
      e.stopPropagation();
      toggle();
    }, true);

    // Tap fuera: cierra
    document.addEventListener('pointerdown', (e) => {
      if (!mqMobile.matches) return;
      if (!e.target.closest('.endura-quiz-wrap')) close();
    });

    // Si cambias a desktop: cierra
    mqMobile.addEventListener('change', () => close());
  }

  document.addEventListener('DOMContentLoaded', init);
})();


  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
